<template>
    <div class="clock-container">
      <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`">
        <circle
          :cx="center"
          :cy="center"
          :r="radius"
          stroke="black"
          stroke-width="1"
          fill="none"
        />
        <text
          v-for="n in 12"
          :key="n"
          :x="getX(n)"
          :y="getY(n)"
          text-anchor="middle"
          alignment-baseline="middle"
          :transform="`rotate(${getRotation(n)}, ${getX(n)}, ${getY(n)})`"
        >
          {{ n }}
        </text>
      </svg>
    </div>
  </template>
  
  <script>
  export default {
    name: "Clock",
    data() {
      return {
        size: 200, // Tamaño del SVG
        center: 100, // Centro del círculo
        radius: 90, // Radio del círculo
      };
    },
    methods: {
      getX(n) {
        return (
          this.center +
          this.radius * Math.sin((2 * Math.PI * n) / 12)
        );
      },
      getY(n) {
        return (
          this.center -
          this.radius * Math.cos((2 * Math.PI * n) / 12)
        );
      },
      getRotation(n) {
        return (360 / 12) * n;
      },
    },
  };
  </script>
  
  <style scoped>
  .clock-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
  }
  </style>
  